import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    /* Leadership Bio grid start */
    if (document.querySelector('.leadership-popup-slider')) {
        // Check if Swiper slider is already initialized
        initSwiper();
    }

    document.querySelectorAll('.leadership-grid-section .lgs-img.-bio, .lgs-title.-bio').forEach(function(element) {
        element.addEventListener('click', function() {
            document.body.classList.add('scroll-fixed');
            const targetId = element.getAttribute('data-href');
            navigateToSlide(targetId);
            element.closest('.lgs-wrap').classList.add('is-visible');
            setTimeout(function() {
                document.querySelector('.lgs-wrap.is-visible').querySelector('.lgs-popup').classList.add('is-visible');
            }, 300);
        });
    });

    document.addEventListener('click', function(event) {
        if (event.target.closest('.leadership-grid-section .lgs-popup-close-btn') || event.target.closest('.lgs-popup-overlay')) {
            document.body.classList.remove('scroll-fixed');
            const wrap = document.querySelector('.leadership-grid-section .lgs-wrap');
            const popup = document.querySelector('.leadership-grid-section .lgs-popup');
            if (wrap) {wrap.classList.remove('is-visible');}
            if (popup) {popup.classList.remove('is-visible');}
        }
    });
    /* Leadership Bio grid End */

    function navigateToSlide(targetId) {
        const sliders = document.querySelectorAll('.leadership-popup-slider');
        sliders.forEach(function(slider) {
            const targetSlide = slider.querySelector('.lgs-popup-content-wrap[data-id="' + targetId + '"]');
            const slideIndex = Array.from(slider.querySelectorAll('.lgs-popup-content-wrap')).indexOf(targetSlide);
            if (slideIndex !== -1) {
                slider.swiper.slideTo(slideIndex);
            }
        });
    }

    function initSwiper() {
        const lead_slider_all = document.querySelectorAll('.leadership-popup-slider');
        lead_slider_all.forEach(function(slider) {
            new Swiper(slider, {
                freeMode: false,
                slidesPerView: 1,
                autoHeight: true,
                spaceBetween: 30,
                loop: false,
                navigation: {
                    prevEl: slider.parentNode.querySelector('.lgs-button-prev'),
                    nextEl: slider.parentNode.querySelector('.lgs-button-next'),
                },
            });
        });
    }
});
